/********************************************
* Hero sub-menu
********************************************/
function fnHeroSubMenu( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection					= $( oSection ),
		oTrigger					= $( '.dropdown-trigger', oSection ),
		iItemCount					= oSection.find( 'ul li' ).length,
		iDefaultContainerHeight		= 65,
		iMenuItemHeight				= 42;

	/**
	* Click trigger
	*/
	oTrigger.on( 'click', function() {

		// Apply class
		oSection.addClass( 'open' );

		// Adjust height of container
		oSection.find( '.container' ).css({
			'max-height':			( iItemCount * iMenuItemHeight + ( iDefaultContainerHeight + 20 ) )
		});

	});

}


// END OF DOCUMENT
